export const SCHEDULE_TIME_TYPE_START_TIMES = 'start_times'
export const SCHEDULE_TIME_TYPE_OPENING_HOURS = 'opening_hours'
export const SCHEDULE_TIME_TYPE_COORDINATED = 'coordinated_start_times'

export const SCHEDULE_TIME_TYPES = {
  startTimes: SCHEDULE_TIME_TYPE_START_TIMES,
  openingHours: SCHEDULE_TIME_TYPE_OPENING_HOURS,
  coordinatedStartTimes: SCHEDULE_TIME_TYPE_COORDINATED
}
